import CommentIcon from '@atlaskit/icon/core/comment';
import Link from '@atlaskit/link';
import { LinkItem } from '@atlaskit/menu';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { lazy, Suspense } from 'react';
import { useIntl } from 'react-intl-next';

import { useHelpStore } from './help-provider';
import { HelpSkeleton } from './help-skeleton';
import messages from './messages';

const Help = lazy(() => import(/* webpackChunkName: "Help" */ '@atlaskit/help'));

export const HelpContents = () => {
	const { toggle } = useHelpStore();
	const { formatMessage } = useIntl();

	return (
		<Suspense fallback={<HelpSkeleton />}>
			<Help header={{ onCloseButtonClick: toggle }} footer={<Footer />}>
				<Box paddingBlockStart="space.100">
					<Stack space="space.200">
						<LinkItem
							iconBefore={<CommentIcon label="comment" />}
							description={formatMessage(messages.slackHelpDescription)}
							shouldDescriptionWrap
							href="https://atlassian.enterprise.slack.com/archives/C08TMKPDKUY"
							target="_blank"
							rel="noopener noreferrer"
							testId="in-product-help-slack-link"
						>
							{formatMessage(messages.askForHelpLink)}
						</LinkItem>
					</Stack>
				</Box>
			</Help>
		</Suspense>
	);
};

const Footer = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={footerStyles}>
			<Link href="https://www.atlassian.com/company/about" appearance="subtle">
				{formatMessage(messages.aboutLink)}
			</Link>
			<Link href="https://www.atlassian.com/legal/customer-agreement" appearance="subtle">
				{formatMessage(messages.termsOfUseLink)}
			</Link>
			<Link href="https://www.atlassian.com/legal/privacy-policy" appearance="subtle">
				{formatMessage(messages.privacyPolicyLink)}
			</Link>
		</Box>
	);
};

const footerStyles = xcss({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	paddingBlockStart: 'space.050',
	paddingBlockEnd: 'space.050',
	gap: 'space.150',
	font: 'font.body.smallest',
	color: 'color.text.subtlest',
});
